import { mapActions, mapGetters } from 'vuex';

//---helpers
import { globalLoader } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import IconLocation from '@/components/icons/IconLocation.vue';
import IconTime from '@/components/icons/IconTime.vue';
import IconLetter from '@/components/icons/IconLetter.vue';
import IconPhone from '@/components/icons/IconPhone.vue';
import ContactsCard from '@/components/cards/ContactsCard/index.vue';
import ContactsForm from '@/modules/StaticPages/Contacts/ContactsForm/index.vue';

export default {
  name: 'Contacts',
  mixins: [dynamicHead],
  components: { ContactsCard, IconPhone, IconLetter, IconTime, IconLocation, BreadcrumbsSimple, ContactsForm },
  props: {},
  data() {
    return {
      contactsData: null
    };
  },
  created() {
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      contacts: 'setting/variables'
    }),
    contactsWithMap() {
      return this.contacts?.contactInfo.filter((info) => !!info.map) || [];
    },

    contactsWithoutMap() {
      return this.contacts?.contactInfo.filter((info) => !info.map) || [];
    }
  },
  methods: {
    ...mapActions({
      getContacts: 'staticPages/GET_CONTACTS',
      getPage: 'staticPages/GET_PAGE'
    }),
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];

      promiseCollection.push(
        this.getContacts().then((result) => {
          this.contactsData = result;
          console.log('result', result);
        })
      );

      promiseCollection.push(
        this.getPage('contact').then((data) => {
          this.newsData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection);
      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.newsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
